import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import store from 'stores/store';
import './i18n';

// styles
import 'bootstrap/dist/css/bootstrap.min.css';

// components
import Main from './Main';
import ErrorBoundaryWrapper from 'components/errorPage';

// prevent mouse wheel from changing focused number input values
document.addEventListener(
	'wheel',
	(e) => {
		const el = document.activeElement;
		if (el instanceof HTMLInputElement && el.type === 'number' && el === e.target) el.blur();
	},
	{ passive: true },
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<ErrorBoundaryWrapper>
		<Provider store={store}>
			<Main />
		</Provider>
	</ErrorBoundaryWrapper>,
);
